export default __webpack_public_path__ + "static/media/recording-running-icon.26fc9f20.svg";